import styled from "styled-components";
import RifleIcon from "./../../../assets/rifle.svg";

const Container = styled.div`
    div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        line-height: 2;

        margin: 0;
        padding: 0;

        p:first-of-type {
            color: #be9c42;
        }

        p:last-of-type {
            color: #bbbbbb;
        }

        * {
            width: 33.3%;
            padding: 0;
            margin: 0;
        }

        img {
            height: 22px;
        }
    }

    & > p {
        color: #555;
        font-size: 8pt;
    }
`;

export default function FeedEntry({ executor, executed, time, id }) {
    const date = new Date(Date.parse(time) - 1000 * 60 * 60 * 5);

    return (
        <Container>
            <div>
                <p>{executor}</p>
                <img src={RifleIcon}/>
                <p>{executed}</p>
            </div>
            <p>{date.toLocaleDateString()} {date.toLocaleTimeString()} {id && `(${id})`}</p>
        </Container>
    );
}